/**
 * AdminPageHeader — Enterprise-uniforme paginakop voor alle admin secties.
 *
 * Release 1.C — Design System.  Gebruikt brand-tokens uit tailwind.config.js
 * i.p.v. hardcoded hex-waarden (#0A192F etc.), zodat pagina's overal
 * consistent zijn en dark-mode / theming voorbereid is.
 *
 * Props:
 *   title       string  (verplicht)
 *   subtitle    string  (optioneel — kleine helptekst onder titel)
 *   icon        Lucide-icoon component (optioneel — badge links van titel)
 *   badge       ReactNode  (optioneel — pill rechts van titel, bv. "Live")
 *   actions     ReactNode  (optioneel — knoppenrij rechts)
 *   sticky      boolean  (optioneel — vaste header bij scrollen)
 *   testid      string  (data-testid van de wrapper)
 */
import React from "react";

export default function AdminPageHeader({
  title,
  subtitle,
  icon: Icon,
  badge,
  actions,
  sticky = false,
  testid = "admin-page-header",
}) {
  return (
    <div
      className={
        `flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 pb-4 border-b border-slate-200 ` +
        (sticky ? "sticky top-0 z-20 bg-white/95 backdrop-blur-sm py-3 -mx-4 sm:-mx-6 px-4 sm:px-6" : "")
      }
      data-testid={testid}
    >
      <div className="min-w-0 flex-1 flex items-start gap-3">
        {Icon ? (
          <div className="hidden sm:flex items-center justify-center w-11 h-11 rounded-xl bg-brand-50 border border-brand-100 text-brand-500 flex-shrink-0">
            <Icon className="w-5 h-5" />
          </div>
        ) : null}
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <h1
              className="font-chivo font-bold tracking-tight text-brand-900 text-2xl sm:text-[26px] leading-tight truncate"
              data-testid="admin-page-title"
            >
              {title}
            </h1>
            {badge}
          </div>
          {subtitle ? (
            <p className="text-sm text-ink-500 mt-1" data-testid="admin-page-subtitle">
              {subtitle}
            </p>
          ) : null}
        </div>
      </div>
      {actions ? (
        <div
          className="flex items-center gap-2 flex-wrap sm:flex-nowrap sm:justify-end"
          data-testid="admin-page-actions"
        >
          {actions}
        </div>
      ) : null}
    </div>
  );
}
